import React from "react";
import BaseButton from "@/components/BaseButton";
import { useTranslation } from "react-i18next";

export type StairsPopupOption = {
  floorId: string;
  floorLabel: string;
  direction: "up" | "down";
};

interface StairsPopupContentProps {
  options: StairsPopupOption[];
  onSelect: (floorId: string) => void;
  linkType?: "stairs" | "elevator";
}

const StairsPopupContent: React.FC<StairsPopupContentProps> = ({
  options,
  onSelect,
  linkType = "stairs",
}) => {
  const { t } = useTranslation();
  if (options.length === 0) {
    return null;
  }

  const title = linkType === "elevator" ? t("このエレベーターで移動") : t("この階段で移動");

  return (
    <div className="flex flex-col gap-3 px-2 py-1 text-center text-TextPrimary">
      <p className="text-sm font-semibold">{title}</p>
      <div className="flex flex-col gap-2">
        {options.map((option) => {
          const label =
            option.direction === "up"
              ? t("{{floor}}へ上がる", { floor: option.floorLabel })
              : t("{{floor}}へ下りる", { floor: option.floorLabel });
          return (
            <BaseButton
              key={option.floorId}
              className="w-full"
              textVariant="body/m"
              onClick={() => onSelect(option.floorId)}
            >
              {label}
            </BaseButton>
          );
        })}
      </div>
    </div>
  );
};

export default StairsPopupContent;
